<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>

<page-content>
  <data-table (detail)="onDetail($event)" (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns"
                  [dataProviderParams]="params" [dataProvider]="legacyCompositionService" [searchColumns]="searchColumns"
                  [title]="'Legacy Compositions'"></data-table>
</page-content>
